import request from '@/api/base'

const getRoleGroups = (params) => {
  // params.mockApi = true
  return request.post('/portal/roleGroup/getRoleGroups', params)
}
const insertRole = (params) => {
  return request.post('/portal/role/insertRole', params)
}
const updateRole = (params) => {
  // params.mockApi = true
  return request.post('/portal/role/updateRole', params)
}
const deleteRole = (params) => {
  // params.mockApi = true
  return request.post('/portal/role/deleteRole', params)
}
// 角色组相关
const deleteRoleGroup = (params) => {
  // params.mockApi = true
  return request.post('/portal/roleGroup/deleteRoleGroup', params)
}
const insertRoleGroup = (params) => {
  // params.mockApi = true
  return request.post('/portal/roleGroup/insertRoleGroup', params)
}
const updateRoleGroup = (params) => {
  // params.mockApi = true
  return request.post('/portal/roleGroup/updateRoleGroup', params)
}

// 获取菜单树
const addRoleMenus = (params) => {
  // params.mockApi = true
  return request.post('/portal/role/addRoleMenus', params)
}
const getTreeMenus = (params) => {
  // params.mockApi = true
  return request.get('/portal/menu/getMenuTreebyParkId', {params})
}
const getMenusByRole = (params) => {
  // params.mockApi = true
  return request.post('/portal/menu/getMenusByRole', params)
}
// 把用户从角色中删除
const deleteParkAdminUserByUserIdandRole = (params) => {
  // params.mockApi = true
  return request.post('/portal/menu/deleteParkAdminUserByUserIdandRole', params)
}
const addRoleLatitude = (params) => {
  // params.mockApi = true
  return request.post('/ipark-admin/meshing/latitude/addRoleLatitude', params)
}
export default {
  getRoleGroups,
  insertRole,
  updateRole,
  deleteRole,
  insertRoleGroup,
  updateRoleGroup,
  deleteRoleGroup,
  getTreeMenus,
  addRoleMenus,
  getMenusByRole,
  deleteParkAdminUserByUserIdandRole,
  addRoleLatitude
}



// WEBPACK FOOTER //
// ./src/area-common/api/roleService.js